import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DownloadService {
  constructor(private http: HttpClient) {
    console.log('CREATED DOWNLOAD SERVICE');
  }

  public downloadFile(url: string, context?: string) {
    const requestHeaders = {};
    if (context) {
      requestHeaders['X-Resto-Context'] = context;
    }
    return new Promise((resolve, reject) => {
      this.http
        .get(url, {
          responseType: 'blob',
          observe: 'response',
          headers: new HttpHeaders(requestHeaders)
        })
        .subscribe(({ body, headers }: HttpResponse<Blob>) => {
          const contentDisposition = headers.get('content-disposition');
          const filename = contentDisposition
            ? contentDisposition.replace(
                /attachment; filename="?([^"]*)"?/,
                '$1'
              )
            : 'download';
          const type = body.type;
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(
            new Blob([body], { type })
          );
          downloadLink.download = filename;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.parentNode.removeChild(downloadLink);
          resolve(null);
        });
    });
  }
}
